import { styled, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import React from "react";

export default function BasicDatePicker({
  placeholder = "Select Date",
  size = "small",
  value = null,
  handleChange = () => null,
  ...props
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Date
        value={value ? dayjs(value) : null}
        sx={{ width: "100%" }}
        onChange={handleChange}
        {...props}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            fullWidth
            size={size}
          />
        )}
      />
    </LocalizationProvider>
  );
}

const Date = styled(DatePicker)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    top: "50%", // Center the label vertically
    transform: "translateY(-50%)", // Adjust for vertical centering
    transition: "all 0.2s ease-in-out", // Smooth transition
    left: "16px",
    fontSize: "0.875rem", // Reduced font size (14px)
  },
  "& .MuiInputLabel-shrink": {
    color: theme.palette.text.primary, // Color when focused or filled
    top: 0, // Move the label up when focused or filled
    transform: "translateY(-50%)", // Shift up
    fontSize: "0.75rem", // Even smaller font size when floating (12px)
  },
  "& input": {
    padding: "9px 10px",
    fontSize: theme.typography.subtitle2.fontSize,
    color: theme.palette.text.primary,
  },
  "& fieldset": {
    border: `1px solid ${theme.palette.border.default} !important`,
    borderRadius: "8px",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "#000 !important", // Force black color on disabled input
    "-webkit-text-fill-color": "#000 !important", // For Safari
  },
}));
